import { createWithEqualityFn as create } from 'zustand/traditional'
import { shallow } from 'zustand/vanilla/shallow'

import { createSelectors } from '@/shared/lib/createSelectors.ts'

import { FilterStore, filterStoreBody } from './filterStorePrototype'

export const useFiltersStoreBase = create<FilterStore>(filterStoreBody, shallow)

export const useFiltersStore = createSelectors(useFiltersStoreBase)
